// extracted by mini-css-extract-plugin
export default {"header":"machine-sale-statistic-part_header__ExKEq","period":"machine-sale-statistic-part_period__zD8Di"};